import script from "./InformationForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./InformationForm.vue?vue&type=script&setup=true&lang=ts"

import "./InformationForm.vue?vue&type=style&index=0&id=5e3e8fb6&lang=sass&scoped=true"

import exportComponent from "/home/ec2-user/environment/test_front_adachi/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e3e8fb6"]])

export default __exports__